import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Atributo, CategoriaDTO } from 'app/main/apps/shared/interfaces/categoria.interface';
import { ServicioDTO } from 'app/main/apps/shared/interfaces/servicio.interface';
import { CatalogoService } from 'app/main/apps/shared/services/rest/catalogo.service';
import { DialogService } from 'app/main/apps/shared/services/rest/dialog.service';
import { NotificacionesService } from 'app/main/apps/shared/services/rest/notificaciones.service';
import { finalize } from 'rxjs/operators';
import { DialogPrecioServicioComponent } from '../dialog-precio-servicio/dialog-precio-servicio.component';

@Component({
  selector: 'app-tabla-servicios',
  templateUrl: './tabla-servicios.component.html',
  styleUrls: ['./tabla-servicios.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class TablaServiciosComponent implements OnInit {
  @Output() refrescarTablaEmitter : EventEmitter<number> = new EventEmitter();
  
  servicios:ServicioDTO[];
  @Input() atributos:Atributo[];

  dataSource: MatTableDataSource<ServicioDTO> | null;
  displayedColumns = [];

  constructor(private _catalogoSrvc: CatalogoService,
              private _dialogSrvc: DialogService, 
              private _notificacionesSrvc: NotificacionesService,
              private _fuseProgressBarService: FuseProgressBarService,
              ) {

                
               }

  ngOnInit(): void {
    if (this.atributos.length>0){
      this.displayedColumns = ['nombre'];
      this.atributos.forEach(e=>{
        //console.log(e.descripcion);
        this.displayedColumns.push(e.descripcion);
      })
      this.displayedColumns.push('medida');
      this.displayedColumns.push('tiempo');
      this.displayedColumns.push('precio');
      this.displayedColumns.push('borrar');
    }
    else{
      this.displayedColumns = ['nombre','medida','tiempo','precio','borrar'];
    }
    //console.log('this.displayedColumns');
    //console.log(this.displayedColumns);

    this._catalogoSrvc.onServiciosChanged.subscribe(resp=>{
      this.servicios=resp;
      this.dataSource = new MatTableDataSource(this.servicios);
      //console.log(this.servicios);
    });
  }

  cambiarPrecio(servicio:CategoriaDTO) {
    const dialogRef = this._dialogSrvc.abrirDialog(
      DialogPrecioServicioComponent,
        "clase-dialog",
        "700px",
        servicio
    );

    dialogRef.afterClosed().subscribe((result) => {
        if (result){
          this._fuseProgressBarService.show()
          this._catalogoSrvc.savePrecioServicios(servicio.id, result.desde, result.hasta)
            .pipe(finalize(()=>{this._fuseProgressBarService.hide()}))
            .subscribe(resp=>{
            this._notificacionesSrvc.mostrarNotificacion('Precio cambiado exitosamente', 'success');
            this.refrescarTablaEmitter.emit();
          });        
        }
    });
  }

  borrar(servicio:CategoriaDTO){
    const dialogRef = this._dialogSrvc.abrirDialogConfirm(
      "Borrar Servicio",
      `¿Esta seguro de borrar el servicio ${servicio.descripcion}?`
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
          this._fuseProgressBarService.show();
          this._catalogoSrvc
              .deleteServicio(servicio.id)
              .pipe(finalize(() => this._fuseProgressBarService.hide()))
              .subscribe((resp) => {
                  this._notificacionesSrvc.mostrarNotificacion(
                      "Servicio Borrado",
                      "success"
                  );
                  //refresh
                  this.refrescarTablaEmitter.emit();
              });
      }
  });

  }

}
